import {  FC, Suspense, ReactNode } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import DashboardWrapper  from '../pages/dashboard/DashboardWrapper'

import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
const PrivateRoutes = () => {
  //const DashboardWrapper = lazy(() => import('../pages/dashboard/DashboardWrapper'))


  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard/*' element={
          
            <DashboardWrapper />
          

        } />

        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              
            </SuspensedView>
          }
        />



        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

type SuspensedViewProps = {
  children?: ReactNode
}

const SuspensedView: FC<SuspensedViewProps> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
